import { AutogenModelRoutes, AutogenRowRoutes } from "./autogen/AutogenModelRoutes";

export class ModelRoutes extends AutogenModelRoutes<RowRoutes> {
	constructor() {
		super(RowRoutes);
	}
}

export class RowRoutes extends AutogenRowRoutes {
}